import Columns from 'columns.js';

var debounce = require('debounce');

export const columns = ($el, $breakpoints = {640: 2, 764: 3, 1024: 4}) => {

  let gridEl = $el.getElementsByClassName('js-fsa-columns')[0]

  let grid = new Columns(gridEl, {
    columns: 1,
    breakpoints: $breakpoints,
    algorithm: 'chronological',
    column_class: 'blog_card'
  });

  window.addEventListener('resize', debounce(() => {
    grid.render();
  }, 50));

}
